const { REACT_APP_ENV, REACT_APP_DNS_API_WALL } = process.env
const ENV = REACT_APP_ENV
const socketURL = REACT_APP_DNS_API_WALL.split('//')[1]

const BASE_URL = {
  test: 'http://localhost:5000',
  local: 'http://localhost:5000',
  development: REACT_APP_DNS_API_WALL,
  pre: REACT_APP_DNS_API_WALL,
  production: REACT_APP_DNS_API_WALL,
}

const HOST_SOCKETS = {
  test: {
    hostname: 'localhost',
    port: 5000,
    secure: false,
  },
  local: {
    hostname: socketURL,
    port: 443,
    secure: true,
  },
  development: {
    hostname: socketURL,
    port: 443,
    secure: true,
  },
  pre: {
    hostname: socketURL,
    port: 443,
    secure: true,
  },
  production: {
    hostname: socketURL,
    port: 443,
    secure: true,
  },
}

export default {
  URL: BASE_URL[ENV],
  SOCKET: HOST_SOCKETS[ENV],
}
